<div class="entry-panel" *ngIf="form" [formGroup]="form">
  <div class="entry-header">
    <div class="entry-title">
      <h2>Add Invoice / Credit</h2>
      <p>Enter or upload a miscellaneous vendor invoice or credit.</p>
    </div>
    <div class="upload-action">
      <input
        #fileInput
        type="file"
        accept="application/pdf,image/*"
        hidden
        (change)="onFileSelected($event)"
      />
      <button
        mat-raised-button
        type="button"
        color="primary"
        (click)="fileInput.click()"
        [disabled]="scanBusy"
      >
        <mat-icon>document_scanner</mat-icon>
        <span>{{ uploadLabel }}</span>
      </button>
    </div>
  </div>

  <div class="scan-strip">
    <span class="hint">
      PDF, photo, or scan. Suggested fields must be reviewed before saving.
    </span>
    <span class="file-name" *ngIf="attachment?.originalName">{{ attachment.originalName }}</span>
    <span class="warn" *ngIf="attachment?.uploadError">The file could not be stored. Try the upload again.</span>
    <span class="warn" *ngIf="duplicateInvoice">This document number already exists for the vendor.</span>
  </div>

  <mat-button-toggle-group
    class="type-toggle"
    formControlName="entryType"
    name="entryType"
  >
    <mat-button-toggle value="invoice">Invoice</mat-button-toggle>
    <mat-button-toggle value="credit">Credit</mat-button-toggle>
  </mat-button-toggle-group>

  <div class="identity">
    <div class="vendor-col">
      <mat-form-field class="compact vendor-field" [style.width]="vendorWidth">
        <mat-label>Vendor</mat-label>
        <mat-select formControlName="vendor">
          <mat-option *ngFor="let vendor of vendors" [value]="vendor._id">
            {{ vendor.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field class="compact currency-field">
        <mat-label>Currency</mat-label>
        <mat-select formControlName="currency">
          <mat-option *ngFor="let code of currencies" [value]="code">{{ code }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="doc-col">
      <mat-form-field class="compact doc-field">
        <mat-label>{{ kindLabel }} Number</mat-label>
        <input matInput formControlName="invoiceNumber" autocomplete="off" />
      </mat-form-field>
      <mat-form-field class="compact doc-field">
        <mat-label>{{ kindLabel }} Date</mat-label>
        <input matInput [matDatepicker]="picker" formControlName="date" />
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <div class="pricing">
    <mat-form-field class="compact price-field">
      <mat-label>{{ moneyLabel('Shipping') }}</mat-label>
      <span matPrefix>{{ currencySymbol }}&nbsp;</span>
      <input matInput type="number" formControlName="shipping" />
    </mat-form-field>
    <mat-form-field class="compact price-field">
      <mat-label>{{ moneyLabel('Tax') }}</mat-label>
      <span matPrefix>{{ currencySymbol }}&nbsp;</span>
      <input matInput type="number" formControlName="tax" />
    </mat-form-field>
    <mat-form-field class="compact price-field">
      <mat-label>{{ moneyLabel('Price') }}</mat-label>
      <span matPrefix>{{ currencySymbol }}&nbsp;</span>
      <input matInput type="number" formControlName="price" />
    </mat-form-field>
    <mat-form-field class="compact price-field">
      <mat-label>{{ moneyLabel('Total') }}</mat-label>
      <span matPrefix>{{ currencySymbol }}&nbsp;</span>
      <input matInput [value]="total | number:'1.2-2'" readonly tabindex="-1" />
    </mat-form-field>
    <mat-form-field class="compact price-field">
      <mat-label>USD Total</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput [value]="usdTotal | number:'1.2-2'" readonly tabindex="-1" />
    </mat-form-field>
  </div>

  <mat-form-field class="notes-field">
    <mat-label>Notes</mat-label>
    <textarea matInput formControlName="notes" rows="2"></textarea>
  </mat-form-field>

  <div class="entry-footer">
    <mat-form-field class="compact initials-field">
      <mat-label>Initials</mat-label>
      <input matInput formControlName="initials" maxlength="4" autocomplete="off" />
    </mat-form-field>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="save()"
      [disabled]="form.invalid || saving"
    >
      {{ saving ? 'Saving…' : 'Save ' + kindLabel }}
    </button>
  </div>
</div>
